var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4473 2.23242C12.8584 2.23242 12.2695 2.46094 11.8125 2.91797L2.91797 11.8125L2.88281 11.9883L2.26758 15.082L2.0918 15.9082L2.91797 15.7324L6.01172 15.1172L6.1875 15.082L15.082 6.1875C15.9961 5.27344 15.9961 3.83203 15.082 2.91797C14.625 2.46094 14.0361 2.23242 13.4473 2.23242ZM13.4473 3.30469C13.7307 3.30469 14.0164 3.43433 14.291 3.70898C14.8381 4.2561 14.8381 4.84937 14.291 5.39648L13.8867 5.7832L12.2168 4.11328L12.6035 3.70898C12.8782 3.43433 13.1638 3.30469 13.4473 3.30469ZM11.4258 4.9043L13.0957 6.57422L6.29297 13.377C5.92383 12.6562 5.34375 12.0762 4.62305 11.707L11.4258 4.9043ZM3.90234 12.6211C4.5769 12.8936 5.10645 13.4231 5.37891 14.0977L3.5332 14.4668L3.90234 12.6211Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a3b0be6d5c8c674d5c9721f4ee7930ad.svg";
export { ForwardRef as ReactComponent };